var _path, _circle, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg026Presentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bold",
    enableBackground: "new 0 0 32 32",
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26 32h-20c-3.314 0-6-2.686-6-6v-20c0-3.314 2.686-6 6-6h20c3.314 0 6 2.686 6 6v20c0 3.314-2.686 6-6 6z",
    fill: "#ffe6e2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.667,
    cy: 17.667,
    fill: "#fc573b",
    r: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m13.5 20.667h-3.667c-1.011 0-1.833.822-1.833 1.833v1c0 .276.224.5.5.5h6.333c.276 0 .5-.224.5-.5v-1c0-1.011-.822-1.833-1.833-1.833z",
    fill: "#fc573b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m22.833 8h-10.333c-.64 0-1.167.527-1.167 1.167v5.52c.107-.013.22-.02.333-.02 1.54 0 2.813 1.167 2.98 2.667h1.354v2.166c0 .22.14.413.353.48.047.013.1.02.147.02.16 0 .32-.08.413-.22l1.68-2.447h4.24c.64 0 1.167-.527 1.167-1.167v-7c0-.639-.527-1.166-1.167-1.166zm-.946 2.82-2.5 3c-.18.213-.493.24-.707.067l-1.66-1.387-2.18 2.033c-.093.087-.22.133-.34.133-.133 0-.267-.053-.367-.16-.187-.2-.173-.52.027-.707l2.5-2.333c.18-.173.467-.18.66-.02l1.613 1.347 2.18-2.613c.18-.213.493-.24.707-.067.213.18.24.494.067.707z",
    fill: "#fd907e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg026Presentation);
export default __webpack_public_path__ + "static/media/026-presentation.1a32b29184fda2d68c8c90d3054aff5c.svg";
export { ForwardRef as ReactComponent };